<emperor-dialog-header
  title="Are you sure you want to {{
    data.activate ? 'reactivate' : 'deactivate'
  }} this account?"
  [color]="EmperorCardHeaderColor.NONE"
  [class.warn]="!data.activate"
></emperor-dialog-header>

<emperor-card-content>
  <p *ngIf="!data.activate">
    <ng-container *ngIf="data.hasInvitationBeenSent; else cancelSendingInvite">
      This user will be signed out and will no longer have access to their Bold
      Penguin account.
    </ng-container>
    <ng-template #cancelSendingInvite>
      This user will not receive an invitation and will not have access to the
      Bold Penguin Terminal.
    </ng-template>
  </p>
  <p *ngIf="data.activate">This will send the agent a new invitation email.</p>
</emperor-card-content>

<emperor-card-footer [color]="EmperorCardHeaderColor.NONE">
  <emperor-button
    [uiButtonType]="emperorUIButtonTypes.Text"
    class="text-uppercase cancel-button"
    [color]="EmperorThemeColor.PRIMARY"
    emperorDialogClose
    >No, Cancel</emperor-button
  >
  <emperor-button
    [uiButtonType]="emperorUIButtonTypes.Standard"
    class="text-uppercase"
    [color]="data.activate ? EmperorThemeColor.PRIMARY : EmperorThemeColor.WARN"
    (click)="confirm()"
    emperorDialogClose
    >Yes, {{ data.activate ? 'Re' : 'De' }}activate</emperor-button
  >
</emperor-card-footer>
